
const exRegister = () => import('../views/pages/exRegister/index.vue');
const register = () => import('../views/pages/exRegister/register.vue'); // 展商注册页
const registerM = () => import('../views/pages/exRegister/register-mobile.vue'); // 展商注册页
const registerResult = () => import('../views/pages/exRegister/register-result.vue'); // 展商注册-结果页面
//展位预定信息

// 英文

const registerEn = () => import('../views/pages/exRegister/En/register.vue'); // 展商注册页 
const registerMEn = () => import('../views/pages/exRegister/En/register-mobile.vue'); // 展商注册页
const registerResultEn = () => import('../views/pages/exRegister/En/register-result.vue'); // 展商注册-结果页面

const exRegisterRouter = [
  {
    path: '/ex-register', redirect: '/ex-register/register', name: 'ex-register', component: exRegister, children: [
      {
        path: 'register', name: 'register', component: register, meta: { requireAuth: false }
      },
      {
        path: 'register-mobile', name: 'register-mobile', component: registerM, meta: { requireAuth: false }
      },
      {
        path: 'register-result', name: 'registerResult', component: registerResult, meta: { requireAuth: false }
      },
    ]
  },
  {
    path: '/ex-register-en', redirect: '/ex-register-en/register', name: 'ex-register-en', component: exRegister, children: [
      {
        path: 'register', name: 'register', component: registerEn, meta: { requireAuth: false }
      },
      {
        path: 'register-mobile', name: 'register-mobile', component: registerMEn, meta: { requireAuth: false }
      },
      {
        path: 'register-result', name: 'register-result-en', component: registerResultEn, meta: { requireAuth: false }
      },
    ]
  }
]


export {
  exRegisterRouter,
}; 
